export const TIME_RANGES = [
  { value: '1h', labelId: 'nodes.statistics.timeRange.1h', interval: 'minute', hours: 1, limit: 60 },
  { value: '6h', labelId: 'nodes.statistics.timeRange.6h', interval: 'minute', hours: 6, limit: 360 },
  { value: '24h', labelId: 'nodes.statistics.timeRange.24h', interval: 'hour', hours: 24, limit: 24 },
  { value: '7d', labelId: 'nodes.statistics.timeRange.7d', interval: 'day', hours: 24 * 7, limit: 168 },
]
